<template>
	<pre :class="{'whitespace-pre-wrap break-all': wrap}">{{ value.data.stack || value.data.message }}</pre>
</template>

<script>
export default {
	name: 'ArgError',
	props: {value: Object, wrap: Boolean},
}
</script>
